import { createSlice } from "@reduxjs/toolkit";
import { CONTACT } from "../../../constant/reducer_names";

const initialState = {
  individualcontact:{},
}
const ContactSlice = createSlice({
  name: CONTACT,
  initialState,
  reducers: {
    setIndividualContact: (state, { payload }) => {
      state.individualcontact = payload;
    },
    reset: () => { },
  },
});
export const contactAction = ContactSlice.actions;
export default ContactSlice.reducer;